import angular from 'angular';
import spriteMarkup from './assets/icons/sprite.svg';
import './assets/scss/main.scss';

import './app.module';
import './app.config';
import './app.routes';

function mountIconSprite(markup) {
  const wrapper = document.createElement('div');
  wrapper.innerHTML = markup;
  document.body.insertBefore(wrapper.firstElementChild, document.body.firstChild);
}

mountIconSprite(spriteMarkup);

angular.bootstrap(document, ['app'], { strictDi: true });
